import React, { useState } from 'react';
import { Button, Modal } from 'native-base';
import { Icon } from '../../Common/components/Icon';
import { faBookMedical } from '@fortawesome/pro-solid-svg-icons/faBookMedical';
import { DoctorMHRDocumentListView } from './DoctorMHRDocumentListView';
import { DoctorMHRDocumentView } from './DoctorMHRDocumentView';

export function DoctorMHRDocumentSearch({ customerID }: { customerID: string }) {
  const [showModal, setShowModal] = useState(false);
  const [documentID, setDocumentID] = useState<string | null | undefined>(null);
  const [repositoryID, setRepositoryID] = useState<string | null| undefined>(null);

  const backToList = () => {
    setDocumentID(null);
    setRepositoryID(null);
  }

  const closeModal = () => {
    setDocumentID(null);
    setRepositoryID(null);
    setShowModal(false);
  }

  const documentSelected = (documentID: string | null | undefined, repositoryID: string | null | undefined) => {
    setDocumentID(documentID);
    setRepositoryID(repositoryID ?? null);
  }

  return (
    <>
      <Button
        leftIcon={<Icon icon={faBookMedical} />}
        size={'sm'}
        variant={'outline'}
        onPress={() => setShowModal(true)}
      >
        My Health Record - Clinical Documents
      </Button>

      <Modal isOpen={showModal} size={'full'} onClose={closeModal}>
        {showModal && !documentID && !repositoryID && <DoctorMHRDocumentListView customerID={customerID} onDocumentSelect={documentSelected} />}
        {showModal && documentID && repositoryID && <DoctorMHRDocumentView customerID={customerID} documentID={documentID} repositoryID={repositoryID} onBackClicked={backToList} onLoadDocumentCLicked={documentSelected} />}
      </Modal>
    </>
  );
}